import { cloneDeep } from 'lodash';
import { ActiveFilters, SearchFilter } from 'store/search/types';

export default function applySelectionToFilters(filters: SearchFilter[], selection: ActiveFilters) {
  const resultFilters = cloneDeep(filters);
  resultFilters.forEach((filter) => {
    filter.facets.forEach((facet) => {
      if (selection[filter.id]) {
        const isSelected = selection[filter.id].indexOf(facet.value) > -1;
        facet.checked = isSelected;
      }
    });
  });
  return resultFilters;
}
